export default function PHP_substr_replace() {
  return (
    <div>
      <h1>PHP_substr_replace</h1>
    </div>
  );
}
